export default {
  reset: (state) => {
    state.item = {
      first_name: null,
      last_name: null,
      email: null,
      plainPassword: null,
    };
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
};
